import { render } from "./PoolCrowdSection.vue?vue&type=template&id=2be7901e"
import script from "./PoolCrowdSection.vue?vue&type=script&lang=js"
export * from "./PoolCrowdSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__